module.exports = __webpack_public_path__ + "static/media/image-empty-search-state.b9c57153.png";